import { DataSourceMode } from "@mcleod/components";
import { AutogenLayoutMobileCommLoginLogoutHistList } from "./autogen/AutogenLayoutMobileCommLoginLogoutHistList";

export class MobileCommLoginLogoutHistList extends AutogenLayoutMobileCommLoginLogoutHistList {
    afterCrudClose: () => void;

    async onLoad() {
        // Default onLoad implementation
    }

    async searchList() {
        // Default search implementation
        this.tableMobileCommLoginLogoutHist.busy = true;
        await this.sourceMcLoginLogoutHist.search({});
        this.tableMobileCommLoginLogoutHist.busy = false;
    }

    async tableAfterCrudClose(event) {
        if (event.dataSourceMode === DataSourceMode.ADD || event.dataSourceMode === DataSourceMode.UPDATE) {
            this.afterCrudClose?.();
        }
    }

    /**
     * Filters position lookup to show only current positions for login position field
     */
    textboxLoginPositionIdBeforeLookupModelSearch(event) {
        try {
            event.filter.current_positions = true;
        } catch (error) {
            console.error('Error setting login position filter:', error);
        }
    }

    /**
     * Filters position lookup to show only current positions for logout position field
     */
    textboxLogoutPositionIdBeforeLookupModelSearch(event) {
        try {
            event.filter.current_positions = true;
        } catch (error) {
            console.error('Error setting logout position filter:', error);
        }
    }
}
